module.exports = __webpack_public_path__ + "img/03_button.e47411ef.png";